import { Link } from 'react-router-dom';

import './styles/button.css';

function classNames({ variant, size, isBlock, isIconOnly, isBusy, className }) {
    return [
        'button',
        `button--${variant}`,
        size === 'small' && 'button--small',
        isBlock && 'button--block',
        isIconOnly && 'button--icon',
        isBusy && 'button--busy',
        className,
    ].filter(Boolean).join(' ');
}

export default function Button({
    variant = 'secondary',
    size,
    isBlock = false,
    isBusy = false,
    icon,
    label,
    to,
    children,
    className,
    type = 'button',
    disabled,
    ...props
}) {
    const isIconOnly = !!icon && !children;
    const classes = classNames({ variant, size, isBlock, isIconOnly, isBusy, className });
    const content = (
        <>
            {icon && <span className="button__icon">{icon}</span>}
            {children && <span className="button__label">{children}</span>}
            {isIconOnly && <span className="visually-hidden">{label}</span>}
        </>
    );

    if (to) {
        return <Link to={to} className={classes} {...props}>{content}</Link>;
    }
    return (
        <button
            type={type}
            className={classes}
            disabled={disabled || isBusy}
            aria-busy={isBusy || undefined}
            {...props}
        >
            {content}
        </button>
    );
}
